<!-- ng2 File upload -->

<div class="container">
  <div class="row">
    <div class="col">
      <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)"
        (onFileDrop)="fileDrop($event)" class="drop-zone">
        <p class="drop-zone-text text-center">
          {{fileName || " Drag image or pdf here to start uploading"}}
        </p>
        <p class="drop-zone-or">OR</p>
        <input class="file-input" type="file" #fileUpload ng2FileSelect [multiple]="multiple"
          (onFileSelected)="onFileSelected($event)" /><br />
        <div class="file-upload">
          <button mat-raised-button color="accent" aria-label="Browse" (click)="fileUpload.click()">
            Browse files
          </button>
        </div>
      </div>
    </div>
  </div>


